module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_4"
    }
  }, [_c('span', [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("I HAVE")]), _vm._v(" known Emily Chan for years. Way before I was published and even back then, her developing talents were extraordinary. When the idea to illustrate the Bad, Dad, and Dangerous anthology came about, Em was the first person I thought of who could not only work well with all of us but also deliver a unique style to go along with our stories.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Working with Em is such a delight and she put so much care into making sure things laid down right. From Joe’s distrustful scowl to Levi’s wolf form, she pulled the scenes out of my story and breathed life into them. I am in awe of her diverse talent with her being able to illustrate the hell out of the human face to the cute and comedic graphics of her award-winning webcomic, Stupid Fox.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent__And__Tabs"
  }, [_vm._v("I hope to work with Em again in the future — because I’d love to commission a graphic novel from one of Kai’s short stories — of course, that’s something for another day and I hope you enjoy her take on Wolf At First Sight as much as I do.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent__And__Tabs"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("Thanks, Em!")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Alignment__And__Left_Indent__And__Spacing_After__And__Line_Spacing__And__Tabs"
  }, [_vm._v("Rhys Ford")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013f8a62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0